"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _BaseTheme = _interopRequireDefault(require("../../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Awesome = () => /*#__PURE__*/_react.default.createElement("svg", {
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 10C0 4.476 4.476 0 10 0s10 4.476 10 10-4.476 10-10 10S0 15.524 0 10zm5.222-3.714l-1.407.202a.317.317 0 00-.174.536l1.024.992-.242 1.407a.302.302 0 00.444.319l1.262-.657 1.258.653a.302.302 0 00.444-.319l-.242-1.407 1.024-.992a.314.314 0 00-.173-.532l-1.408-.202-.625-1.274a.312.312 0 00-.56 0l-.625 1.274zm10.576 7.049c-.375 2.217-3.354 3.762-5.798 3.762s-5.423-1.545-5.798-3.762a.648.648 0 01.834-.722c1.218.391 3.029.613 4.964.613 1.935 0 3.746-.222 4.964-.613a.645.645 0 01.834.722zm-.463-5.323l1.024-.992a.31.31 0 00-.178-.528l-1.407-.202-.625-1.274a.312.312 0 00-.56 0l-.625 1.274-1.408.202a.315.315 0 00-.173.532l1.024.992-.242 1.407a.302.302 0 00.444.319l1.262-.657 1.262.653a.301.301 0 00.444-.319l-.242-1.407z",
  fill: _BaseTheme.default.colors.lightgray
}));

var _default = Awesome;
exports.default = _default;